export const SUBSCRIPTION_ENDPOINT_KEY = 'subscription'
